import { Mapper } from "../../../../base/utils/mapper";

import { FileDocumentsSystemModel }
from "../../../../domain/models/configuration/file-documents-system.model";

import { FileDocumentsSystemEntity }
from "../entities/file-documents-system.entity";

export class FileDocumentsSystemImplementationRepositoryMapper
extends Mapper<
FileDocumentsSystemEntity,
FileDocumentsSystemModel
> {

    mapFrom(param:
    FileDocumentsSystemEntity):
    FileDocumentsSystemModel {

        return {
            ...param
        };
    }

    mapTo(param:
    FileDocumentsSystemModel):
    FileDocumentsSystemEntity {

        return {
            ...param
        };
    }
}